import React, {Component} from 'react';
import {Button} from 'adminlte-2-react';

class Content extends Component {
  componentDidMount() {
    const {browserTitle} = this.props;
    if (browserTitle) {
      document.title = browserTitle;
    }
  }

  render() {
    const {
      title,
      subTitle,
      children,
      history,
      showBackButton = true,
      onBackClick,
    } = this.props;

    return (
      <React.Fragment>
        <section className="content-header" style={{display: 'flex'}}>
          {showBackButton && (
            <div style={{marginRight: 5}}>
              <Button
                size="sm"
                type="default"
                icon="fa-arrow-left"
                onClick={() => (onBackClick ? onBackClick() : history.goBack())}
              />
            </div>
          )}
          <h1 style={{}}>
            {title} {subTitle ? <small>{subTitle}</small> : ''}
          </h1>
        </section>
        <section className="content">{children}</section>
      </React.Fragment>
    );
  }
}

export {Content};
